import React, { Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import DeliveryCancelledOrderTable from "../common/DeliberyCancelledOrderTable";

const DeliveryCancelledOrders = () => {
    return (
        <Fragment>
            <Breadcrumb title="Delivery Cancelled Orders" parent="Dashboard" />

            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <h5>Orders Detail</h5>
                                {/* <Link to={`/orders/create-order`}>
                                    <Button color="primary">Create Order</Button>
                                </Link> */}
                            </CardHeader>
                            <CardBody className="order-datatable">
                                <DeliveryCancelledOrderTable />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default DeliveryCancelledOrders;
